export default __webpack_public_path__ + "static/pic12-c26c4860e8b9d64b10c451f3a1b4f1ef.jpg";